import { CTA, Text } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { CustomerContactPageViewProps } from './CustomerContactpageViewProps';
import { FieldsGroup } from '../../modules/common-components/FieldsGroup';
import { Form } from '../../modules/forms/Form';
import { CustomerContactPageFormSchema } from './CustomerContactPageFormShema';
import { SelectField } from '../../modules/forms/fields/SelectField';
import { TextInputField } from '../../modules/forms/fields/TextInputField';
import { CheckboxField } from '../../modules/forms/fields/CheckboxField';
import { maxPhoneNumberLength, sanitizePhoneNumber } from '../../utils/PhoneUtils';

const StyledTermsAndConditionsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export function CustomerContactPageVwView({
  initialFormData,
  formRef,
  onPrivacyStatementClick,
  preferredContactMethods,
  prefixes,
}: CustomerContactPageViewProps): ReactElement {
  return (
    <Form schema={CustomerContactPageFormSchema} defaultValues={initialFormData} ref={formRef} firstForm={true}>
      <FieldsGroup>
        <SelectField name="title" label="Title" options={prefixes} required />
        <TextInputField name="name" label="Name" type="text" rules={{ required: true }} />
        <TextInputField name="surname" label="Surname" type="text" rules={{ required: true }} />
        <TextInputField name="email" label="Email" type="email" rules={{ required: true }} />
        <TextInputField
          name="phoneNumber"
          label="Phone"
          type="tel"
          sanitize={sanitizePhoneNumber}
          rules={{ required: true, maxLength: maxPhoneNumberLength }}
        />
        <SelectField name="preferredContactMethodType" label="Preferred method of contact" options={preferredContactMethods} required />
        <CheckboxField
          name="privacyStatementConfirmed"
          label={
            <StyledTermsAndConditionsWrapper>
              <Text>
                I accept the{' '}
                <CTA tag="a" emphasis="tertiary" onClick={onPrivacyStatementClick}>
                  privacy statement
                </CTA>
              </Text>
            </StyledTermsAndConditionsWrapper>
          }
        />
      </FieldsGroup>
    </Form>
  );
}
